<div class="cg-detail">
  @if (loading) {
    <div class="cg-detail-empty">Loading countries...</div>
  } @else if (countries.length == 0) {
    <div class="cg-detail-empty">No countries in this group.</div>
  } @else {
    <div class="cg-detail-chips">
      @for (c of countries; track c.countryId) {
        <span class="cg-chip">{{ c.countryName }}</span>
      }
    </div>
  }
</div>
